import { render, staticRenderFns } from "./UploadDialogMessage.vue?vue&type=template&id=18913e25"
import script from "./UploadDialogMessage.vue?vue&type=script&lang=js"
export * from "./UploadDialogMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports